var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 18,
    fill: "#E9F2FF",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_240_85",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 14,
    width: 24,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8796 26.8266V20.9733C39.8796 19.88 39.053 18.64 38.0263 18.2266L30.5996 15.1866C28.933 14.5066 27.053 14.5066 25.3863 15.1866L17.9596 18.2266C16.9463 18.64 16.1196 19.88 16.1196 20.9733V26.8266C16.1196 33.3466 20.853 39.4533 27.3196 41.24C27.7596 41.36 28.2396 41.36 28.6796 41.24C35.1463 39.4533 39.8796 33.3466 39.8796 26.8266ZM28.9996 29.16V32.6666C28.9996 33.2133 28.5463 33.6666 27.9996 33.6666C27.453 33.6666 26.9996 33.2133 26.9996 32.6666V29.16C25.653 28.7333 24.6663 27.48 24.6663 26C24.6663 24.16 26.1596 22.6666 27.9996 22.6666C29.8396 22.6666 31.333 24.16 31.333 26C31.333 27.4933 30.3463 28.7333 28.9996 29.16Z",
    fill: "#080A0E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_240_85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 41,
    height: 30,
    fill: "#E9F2FF",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.d8bbfc49d66c75a5f049e5f6351f4644.svg";
export { ForwardRef as ReactComponent };